import { useState, useEffect, useCallback } from "react";
import { getExpandedProtocol } from "../lib/getExpandedProtocol";

/**
 * Fetch expanded protocol (protocol + splits + exercises) from Firestore.
 * @param {{ organizationId: string | null, protocolId: string | null }} options
 * @returns {{ protocol: object | null, loading: boolean, error: Error | null, refetch: function }}
 */
export function useExpandedProtocol({ organizationId, protocolId }) {
  const [protocol, setProtocol] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProtocol = useCallback(async () => {
    if (!organizationId || !protocolId) {
      setProtocol(null);
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const data = await getExpandedProtocol({ organizationId, protocolId });
      setProtocol(data);
    } catch (err) {
      setError(err);
      setProtocol(null);
    } finally {
      setLoading(false);
    }
  }, [organizationId, protocolId]);

  useEffect(() => {
    fetchProtocol();
  }, [fetchProtocol]);

  return { protocol, loading, error, refetch: fetchProtocol };
}
